import React, { Component } from 'react';
import PropTypes from 'prop-types';

class EntitySummary extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            expanded: false,
        }
    }

    componentWillMount() {
    }

    toggle() {
        this.setState({
            expanded: this.state.expanded ? false : true
        })
    }

    render() {

        var that = this;
        var toggleClasses = 'fa group-toggle'
        if (this.state.expanded) {
            toggleClasses += ' fa-chevron-down';
        } else {
            toggleClasses += ' fa-chevron-right';
        }

        return(
            <div>
            {(this.props.summary && this.props.summary.length > 0) &&
                <div>
                    <h2 className="group-title" onClick={ this.toggle }>
                        Summary of {this.props.label} (<span className='results-count'>{ this.props.summary.length }</span>)
                        <span className={toggleClasses}/>
                    </h2>

                    <div className={ this.state.expanded ? 'group-body indent-body expanded' : 'group-body indent-body' }>
                    {
                        this.props.summary.map(function(sentence, idx) {
                            return <div key={`es_${idx}`} className="summary-sentence">{sentence}</div>
                        })                      
                    }
                    </div>
                </div>
            }
            </div>
        );
    }
};

EntitySummary.propTypes = {
    summary: PropTypes.array,
    label: PropTypes.string
};

export default EntitySummary;

